import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import { useAuthStore } from '../stores/authStore'
import { authApi } from '../api/auth'

/** 路由鉴权守卫：页面加载时向服务端验证 token 有效性 */
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const accessToken = useAuthStore((s) => s.accessToken)
  const setUser = useAuthStore((s) => s.setUser)
  const logout = useAuthStore((s) => s.logout)
  const [checking, setChecking] = useState(true)
  const [valid, setValid] = useState(false)

  useEffect(() => {
    if (!isAuthenticated || !accessToken) {
      setChecking(false)
      return
    }
    // 已有 token，向服务端验证
    authApi
      .profile()
      .then((user) => {
        setUser(user)
        setValid(true)
      })
      .catch(() => {
        logout()
      })
      .finally(() => setChecking(false))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (checking) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="验证登录状态..." />
      </div>
    )
  }

  if (!isAuthenticated && !valid) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
